import { Injectable } from '@angular/core';

import { LoggerService } from '../logger/logger.service';
import { StorageServiceBase } from './storage.service-base';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService extends StorageServiceBase {
  constructor(logService: LoggerService) {
    super(logService, localStorage);
  }
}
